/* eslint-disable react/no-danger */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectFeatureFlags } from '../../../selectors/ContextSelector';

// initial hydration will bypass such component
const StaticRenderer = ({ children }) => {
    const ref = useRef(null);
    const [render, setRender] = useState(typeof window === 'undefined');
    const featureFlags = useSelector(selectFeatureFlags);

    useEffect(() => {
        if (featureFlags.enableReactRenderingStrategy) {
            const isEmpty = ref.current.innerHTML === '';
            if (isEmpty) {
                setRender(true);
            }
        }
    }, [ref, setRender, featureFlags]);

    return !featureFlags.enableReactRenderingStrategy || render ? (
        children
    ) : (
        <div ref={ref} suppressHydrationWarning dangerouslySetInnerHTML={{ __html: '' }} />
    );
};

StaticRenderer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default StaticRenderer;
